/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */
import type { CloudGraphConversationEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI: CloudGraphConversationEntityAti[] = [
	'ati:cloud:graph:conversation',
];
